import { React, useRef, useState, useEffect } from "react";

import logo from "../Images/logo.webp";

import "./new-register.css";
import "./new-redeemption.css";

import "bootstrap/dist/css/bootstrap.min.css";
import secureLocalStorage from "react-secure-storage";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import UserformService from "../services/userform.service";

import $ from "jquery";

import { toast } from "react-toastify";
import { useLayoutEffect } from "react";
import "select2/dist/css/select2.min.css";
import "select2";

function RegisterForm(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Registration Form";

  const [fields, setFields] = useState({
    store_location: "",
    name: "",
    lname: "",
    ticket: "",

    purchase_date: "",
    delivery_date: "",
    model: [],
    // reward: [],
    emailid: "",
    address: "",
    phone: "",
    // dishwasher_quantity: 0,
    // refrigerator_quantity: 0,
    i_agree: "",
  });

  const [errors, setErrors] = useState({});

  const [states, setStates] = useState([]);
  const [locations, setLocations] = useState([]);
  const [models, setModels] = useState([]);
  const [modelsSelected, setModelsSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  const [value_userform, setValue_userform] = useState([]);

  const navigate = useNavigate();

  secureLocalStorage.removeItem("registerform");
  useEffect(() => {
    async function getStates() {
      let errors = {};

      try {
        const response = await UserformService.getStates();

        var states = response.data.response;
        const results = [];
        states.map((value) => {
          return results.push({
            value: value.code,
            label: value.name,
          });
        });
        await setStates([...results]);

        errors["voucher"] = response.data.response;
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    getStates();

    async function getLocations() {
      let errors = {};

      try {
        const response = await UserformService.getStoreLocation();

        var locations = response.data.response;
        const results = [];
        locations.map((value) => {
          return results.push({
            value: value.id,
            label: value.store_name,
          });
        });
        await setLocations([...results]);

        errors["voucher"] = response.data.response;
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }
    getLocations();

    async function getModelsList() {
      let errors = {};

      try {
        const response = await UserformService.getModels();

        var models = response?.data?.response;
        const results = [];

        models?.map((value) => {
          return results.push({
            value: value.name || "",
            label: value.name || "",
            qty: 0,
            type: value.type || "",
          });
        });

        await setModels([...results]);

        errors["voucher"] = response.data.response;
      } catch (err) {
        if (err.status === 429 || err.status === "429") {
          alert("Max Limit Reached. Please wait.");
        }
      }
    }

    getModelsList();
  }, []);
  const ref = useRef();

  const pasted = (e) => {
    e.preventDefault();
    return false;
  };

  const onlyNumbers = (evt) => {
    const { name, value } = evt.target;
    evt.target.value = evt.target.value.replace(/[^0-9]+/g, "");

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: evt.target.value,
      };
    });
  };

  const handleChange = (e) => {
    let { value, name } = e.target;
    if (name === "state" && value === "true") {
      value = "";
    }

    if (name === "i_agree") {
      value = e.target.checked;
    }

    setFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const saveErrors = (err) => {
    setErrors(err);
  };

  const [rewards, setRewards] = useState({
    // dishwasher: {
    //   label: "$200 Virtual Mastercard Reward Card Dishwasher",
    //   qty: 0,
    //   amount: 200,
    // },
    non_dishwasher: {
      label: "Virtual Reward Card",
      qty: 0,
      amount: 0,
    },
  });

  useEffect(() => {
    const qtyByType = (fields.model || []).reduce((acc, item) => {
      acc[item.type] = (acc[item.type] || 0) + Number(item.qty || 0);
      return acc;
    }, {});

    const nonDishwasherQty = qtyByType.non_dishwasher || 0;
    const dishwasherQty = qtyByType.dishwasher || 0;

    const totalQty = nonDishwasherQty + dishwasherQty;

    let rewardAmount = 0;

    // Reward only if at least one non_dishwasher exists
    if (nonDishwasherQty > 0) {
      rewardAmount =
        [0, 100, 250, 400, 600][totalQty] ?? (totalQty >= 5 ? 900 : 0);
    }

    setRewards((prev) => ({
      ...prev,
      non_dishwasher: {
        ...prev.non_dishwasher,
        qty: nonDishwasherQty > 0 ? 1 : 0, // always one reward card
        label: rewardAmount
          ? `$${rewardAmount} Virtual Reward Card`
          : "Virtual Reward Card",
        amount: rewardAmount,
      },
    }));
  }, [fields.model]);

  const activeRewards = Object.entries(rewards).filter(([, v]) => v.qty > 0);

  const submituserRegistrationForm = (e) => {
    e.preventDefault();

    let data = {
      ticket: fields?.ticket,
      store_id: fields?.store_location,
      first_name: fields?.name,
      last_name: fields?.lname,
      purchase_date: fields?.purchase_date,
      delivery_date: fields?.delivery_date,
      email: fields?.emailid,
      address1: fields?.address,
      model: fields?.model,
      reward: rewards,
      phone: fields?.phone,
      // dishwasher_quantity: fields?.dishwasher_quantity,
      // refrigerator_quantity: fields?.refrigerator_quantity,
      i_agree: fields?.i_agree,
    };

    try {
      setLoading(true);
      const responseuserform = UserformService.regData(data);
      responseuserform
        .then((response) => {
          var valueUserform = response?.data?.status;
          setValue_userform(valueUserform);

          secureLocalStorage.setItem(
            "registerform",
            JSON.stringify({
              ticket: fields?.ticket,
              store_id: fields?.store_location,
              name: fields.name,
              lname: fields.lname,
              purchase_date: fields?.purchase_date,
              delivery_date: fields?.delivery_date,
              email: fields?.emailid,
              address1: fields?.address,
              model: fields?.model,
              reward: rewards,
              phone: fields?.phone,
              // dishwasher_quantity: fields?.dishwasher_quantity,
              // refrigerator_quantity: fields?.refrigerator_quantity,
              i_agree: fields?.i_agree,
            }),
          );
          localStorage.removeItem("return_page");
          localStorage.setItem("isRegister", true);
          navigate("/register/registration-thankyou");

          if (value_userform?.includes("redirect")) {
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);

          if (
            err?.response?.data?.message &&
            typeof err?.response?.data?.message === "string"
          ) {
            toast.error(err?.response?.data?.message, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }

          let errorData = {};
          errorData["ticket"] =
            err?.response?.data &&
            err?.response?.data.ticket &&
            err?.response?.data.ticket[0];
          errorData["store_location"] =
            err?.response?.data &&
            err?.response?.data.store_id &&
            err?.response?.data.store_id[0];
          errorData["name"] =
            err?.response?.data &&
            err?.response?.data.first_name &&
            err?.response?.data.first_name[0];
          errorData["lname"] =
            err?.response?.data &&
            err?.response?.data.last_name &&
            err?.response?.data.last_name[0];
          errorData["ticket"] =
            err?.response?.data &&
            err?.response?.data.ticket &&
            err?.response?.data.ticket[0];
          errorData["purchase_date"] =
            err?.response?.data &&
            err?.response?.data.purchase_date &&
            err?.response?.data.purchase_date[0];
          errorData["emailid"] =
            err?.response?.data &&
            err?.response?.data.email &&
            err?.response?.data.email[0];
          errorData["address"] =
            err?.response?.data &&
            err?.response?.data.address1 &&
            err?.response?.data.address1[0];
          errorData["delivery_date"] =
            err?.response?.data &&
            err?.response?.data.delivery_date &&
            err?.response?.data.delivery_date[0];
          errorData["model"] =
            err?.response?.data &&
            err?.response?.data.model &&
            err?.response?.data.model[0];
          errorData["reward"] =
            err?.response?.data &&
            err?.response?.data.reward &&
            err?.response?.data.reward[0];

          errorData["phone"] =
            err?.response?.data &&
            err?.response?.data.phone &&
            err?.response?.data.phone[0];

          errorData["i_agree"] =
            err?.response?.data &&
            err?.response?.data.i_agree &&
            err?.response?.data.i_agree[0];

          saveErrors(errorData);
          setTimeout(() => {
            ref?.current?.focus();
          }, 200);
        });
    } catch (err) {
      alert(err);
      if (err.response.status === 429 || err.response.status === "429") {
        alert("Max Limit Reached. Please wait.");
      }
      let errorData = {};
      errorData["ticket"] = err?.response?.data?.ticket[0];
      errorData["store_location"] = err?.response?.data?.store_id[0];
      errorData["name"] = err?.response?.data?.first_name[0];
      errorData["lname"] = err?.response?.data?.last_name[0];
      errorData["purchase_date"] = err?.response?.data?.purchase_date[0];
      errorData["emailid"] = err?.response?.data?.phone[0];
      errorData["address"] = err?.response?.data?.address1[0];
      errorData["delivery_date"] = err?.response?.data?.delivery_date[0];
      errorData["model"] = err?.response?.data?.model[0];
      errorData["phone"] = err?.response?.data?.phone[0];
      errorData["reward"] = err?.response?.data?.reward[0];

      saveErrors(errorData);
    }
  };

  const Select2Field = ({ name, label, options, value, multiple = false }) => {
    const selectRef = useRef();
    const initializedRef = useRef(false);
    useLayoutEffect(() => {
      if (initializedRef.current) return;
      const $select = $(selectRef.current);

      $select.select2({
        multiple: multiple,
        placeholder: `Select ${label}`,
      });

      $select.on("change", (event) => {
        const selectedValue = $(event.target).val();
        setFields((prevValue) => {
          return {
            ...prevValue,
            [name]: selectedValue,
          };
        });
      });
      initializedRef.current = true;
      return () => {
        $select.select2("destroy");
        $select.off("change");
        initializedRef.current = false;
      };
    }, []);
    useEffect(() => {
      const $select = $(selectRef.current);
      if (!$select.data("select2")) return;
      if (multiple) {
        $select.val(value || []).trigger("change.select2");
      } else {
        $select.val(value || "").trigger("change.select2");
      }
    }, [value, multiple]);
    return (
      <>
        <select
          ref={selectRef}
          name={name}
          className="form-select register-select2"
          value={value || ""}
          id={name}
        >
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </>
    );
  };

  const Select2FieldModel = ({ name, label, options, value = [] }) => {
    const selectRef = useRef();

    useLayoutEffect(() => {
      const $select = $(selectRef.current);

      if ($select.data("select2")) return;

      $select.select2({
        placeholder: `Select ${label}`,
        allowClear: true,
        width: "100%",
      });

      const handleSelect = (event) => {
        const selected = event.params.data;
        const selectedOption = options.find((opt) => opt.value === selected.id);

        setFields((prev) => {
          const existing = prev[name] || [];

          const found = existing.find((item) => item.value === selected.id);

          let updated;

          if (found) {
            updated = existing.map((item) =>
              item.value === selected.id
                ? { ...item, qty: item.qty + 1 }
                : item,
            );
          } else {
            updated = [
              ...existing,
              {
                value: selected.id,
                label: selected.text || selected.id,
                type: selectedOption?.type || "",
                qty: 1,
              },
            ];
          }

          updated.sort((a, b) => a.label.localeCompare(b.label));

          return {
            ...prev,
            [name]: updated,
          };
        });

        $select.val(null).trigger("change");
      };

      $select.on("select2:select.selectQty", handleSelect);

      return () => {
        $select.off(".selectQty");
        $select.select2("destroy");
      };
    }, [name, options]);

    const updateQty = (val, qty) => {
      setFields((prev) => {
        let updated = (prev[name] || []).map((item) =>
          item.value === val ? { ...item, qty } : item,
        );

        updated = updated.filter((item) => item.qty > 0);

        return { ...prev, [name]: updated };
      });
    };

    const removeItem = (val) => {
      setFields((prev) => ({
        ...prev,
        [name]: (prev[name] || []).filter((item) => item.value !== val),
      }));
    };

    return (
      <>
        <select
          ref={selectRef}
          name={name}
          className="form-select register-select2"
          id={name}
        >
          <option value="">Select {label}</option>

          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <div className="reward-cards">
          {(value || []).map((item, index) => (
            <div key={index} className={`reward-card master-card active w-100`}>
              <input
                type="checkbox"
                className="reward-check"
                id={`chk-${item.value}${index}`}
                checked={true}
                onChange={() => removeItem(item.value)}
                onClick={(e) => e.stopPropagation()}
              />

              <label
                htmlFor={`chk-${item.value}${index}`}
                className="reward-name"
                style={{ cursor: "pointer" }}
              >
                {item.label}
              </label>

              <div className="qty-wrap">
                <button
                  type="button"
                  className="qty-btn"
                  onClick={() => updateQty(item.value, item.qty - 1)}
                >
                  −
                </button>

                <div className="qty-val">{item.qty}</div>

                <button
                  type="button"
                  className="qty-btn"
                  onClick={() => updateQty(item.value, item.qty + 1)}
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <section className="form-body-center form-section-bg new-register">
        <div className="container">
          <div className="row gy-4 align-items-center">
            <div className="col-12 col-md-12 col-xl-12">
              <div className="register-logo">
                <img
                  src={logo}
                  alt="city-logo.png"
                  className="img-fluid"
                  width="360"
                  height="118"
                />
              </div>
            </div>
            <div className="col-12 col-md-12 col-xl-12">
              <div className="d-flex justify-content-center text-bg-primary top-bg">
                <div className="col-12 col-xl-12 text-center">
                  <h2 className="form-heading">
                    Register your guest for their Virtual Mastercard Reward
                    Card!
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-12 col-xl-12">
              <div className="card border-0 rounded-4 p-0">
                <div className="card-body p-3 p-md-4 p-xl-5">
                  <form
                    onSubmit={submituserRegistrationForm}
                    name="userRegistrationForm"
                  >
                    <div className="row gy-3 overflow-hidden">
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-pin icon-position"></i>

                          <Select2Field
                            name="store_location"
                            label="Location"
                            options={locations}
                            value={fields["store_location"] || ""}
                          />

                          <label className="form-label form-label-select">
                            Store Location
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.store_location ? errors.store_location : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-account-o icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.name && !errors.store_location
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="name"
                            placeholder="First Name"
                            ref={
                              errors.name && !errors.store_location ? ref : null
                            }
                            value={fields.name || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            First Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.name && !errors.store_location
                            ? errors.name
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <i className="zmdi zmdi-account-o icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            name="lname"
                            style={
                              errors.lname &&
                              !errors.name &&
                              !errors.store_location
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Last Name"
                            value={fields.lname || ""}
                            ref={
                              errors.lname &&
                              !errors.name &&
                              !errors.store_location
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Last Name
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.lname &&
                          !errors.name &&
                          !errors.store_location
                            ? errors.lname
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-ticket-star icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            style={
                              errors.ticket &&
                              !errors.store_location &&
                              !errors.lname &&
                              !errors.name
                                ? { border: "1px solid red" }
                                : null
                            }
                            name="ticket"
                            placeholder="Ticket #"
                            ref={
                              errors.ticket &&
                              !errors.store_location &&
                              !errors.lname &&
                              !errors.name
                                ? ref
                                : null
                            }
                            value={fields.ticket || ""}
                            autoFocus=""
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Ticket #<span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.ticket &&
                          !errors.store_location &&
                          !errors.lname &&
                          !errors.name
                            ? errors.ticket
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <i className="zmdi zmdi-calendar icon-position"></i>

                          <input
                            type="date"
                            className="form-control"
                            name="purchase_date"
                            style={
                              errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Purchase Date"
                            value={fields.purchase_date || ""}
                            ref={
                              errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label form-label-select">
                            Purchase Date
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.purchase_date &&
                          !errors.store_location &&
                          !errors.ticket &&
                          !errors.lname &&
                          !errors.name
                            ? errors.purchase_date
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating">
                          <i className="zmdi zmdi-calendar icon-position"></i>

                          <input
                            type="date"
                            className="form-control"
                            name="delivery_date"
                            style={
                              errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Delivery/Pick-up Date"
                            value={fields.delivery_date || ""}
                            ref={
                              errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label form-label-select">
                            Delivery/Pick-up Date
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.delivery_date &&
                          !errors.purchase_date &&
                          !errors.store_location &&
                          !errors.ticket &&
                          !errors.lname &&
                          !errors.name
                            ? errors.delivery_date
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-local-phone icon-position"></i>

                          <input
                            type="text"
                            name="phone"
                            style={
                              errors.phone &&
                              !errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? { border: "1px solid red" }
                                : null
                            }
                            className="form-control"
                            placeholder="Customer Phone"
                            value={fields.phone || ""}
                            ref={
                              errors.phone &&
                              !errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                            onKeyUp={onlyNumbers}
                            onPaste={pasted}
                            maxLength={10}
                          />

                          <label className="form-label">Customer Phone</label>
                        </div>
                        <div className="errorMsg">
                          {errors.phone &&
                          !errors.delivery_date &&
                          !errors.purchase_date &&
                          !errors.store_location &&
                          !errors.ticket &&
                          !errors.lname &&
                          !errors.name
                            ? errors.phone
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-email-open icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            name="emailid"
                            ref={
                              errors.emailid &&
                              !errors.phone &&
                              !errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? ref
                                : null
                            }
                            style={
                              errors.emailid &&
                              !errors.phone &&
                              !errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? { border: "1px solid red" }
                                : null
                            }
                            placeholder="Email Address"
                            value={fields.emailid || ""}
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Email Address
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.emailid &&
                          !errors.phone &&
                          !errors.delivery_date &&
                          !errors.purchase_date &&
                          !errors.store_location &&
                          !errors.ticket &&
                          !errors.lname &&
                          !errors.name
                            ? errors.emailid
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-store  icon-position"></i>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Mailing Address"
                            name="address"
                            style={
                              errors.address &&
                              !errors.emailid &&
                              !errors.phone &&
                              !errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? { border: "1px solid red" }
                                : null
                            }
                            value={fields.address || ""}
                            ref={
                              errors.address &&
                              !errors.emailid &&
                              !errors.phone &&
                              !errors.delivery_date &&
                              !errors.purchase_date &&
                              !errors.store_location &&
                              !errors.ticket &&
                              !errors.lname &&
                              !errors.name
                                ? ref
                                : null
                            }
                            onChange={handleChange}
                          />

                          <label className="form-label">
                            Mailing Address
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>
                        <div className="errorMsg">
                          {errors.address &&
                          !errors.emailid &&
                          !errors.phone &&
                          !errors.delivery_date &&
                          !errors.purchase_date &&
                          !errors.store_location &&
                          !errors.ticket &&
                          !errors.lname &&
                          !errors.name
                            ? errors.address
                            : null}
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                        <div className="form-floating ">
                          <i className="zmdi zmdi-assignment-o icon-position"></i>
                          <Select2FieldModel
                            name="model"
                            label="Model Number(s)"
                            options={models}
                            value={fields.model || []}
                            multiple={true}
                          />

                          <label className="form-label form-label-select">
                            Model Number
                            <span className="gl-form-asterisk"></span>
                          </label>
                        </div>

                        <div className="errorMsg">
                          {errors.model &&
                          !errors.address &&
                          !errors.emailid &&
                          !errors.phone &&
                          !errors.delivery_date &&
                          !errors.purchase_date &&
                          !errors.store_location &&
                          !errors.ticket &&
                          !errors.lname &&
                          !errors.name
                            ? errors.model
                            : null}
                        </div>
                      </div>
                      <div className="col-lg-8 col-md-12 col-sm-12 mb-3">
                        <div className="reward-section field">
                          <span className="reward-label">
                            Reward Card option (select all that apply and select
                            multiple quantities if buying multiple skus)
                            <span className="req">*</span>
                          </span>

                          <div className="reward-cards">
                            {Object.entries(rewards)?.map(([id, reward]) => {
                              const active = reward?.qty > 0;

                              return (
                                <div
                                  key={id}
                                  className={`reward-card ${active ? "active" : ""}`}
                                >
                                  <input
                                    type="checkbox"
                                    className="reward-check"
                                    id={`chk-${id}`}
                                    checked={active}
                                    readOnly
                                    disabled
                                    style={{ cursor: "not-allowed" }}
                                  />

                                  <label
                                    htmlFor={`chk-${id}`}
                                    className="reward-name"
                                    style={{ cursor: "not-allowed" }}
                                  >
                                    {reward.label}
                                  </label>

                                  {active && (
                                    <div className="qty-wrap">
                                      <div className="qty-val">
                                        {reward.qty}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>

                          <div className="selection-chips">
                            {activeRewards?.map(([id, reward]) => (
                              <div key={id} className="chip-reg">
                                {reward.qty} × {reward.label}
                                {/* <span className="chip-x">✕</span> */}
                              </div>
                            ))}
                          </div>
                          <div className="errorMsg">
                            {errors.reward &&
                            !errors.address &&
                            !errors.emailid &&
                            !errors.phone &&
                            !errors.model &&
                            !errors.delivery_date &&
                            !errors.purchase_date &&
                            !errors.store_location &&
                            !errors.ticket &&
                            !errors.lname &&
                            !errors.name
                              ? errors.reward
                              : null}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 col-sm-12 mt-0">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="i_agree"
                            value={fields.i_agree}
                            onChange={handleChange}
                            id="myCheck"
                          />
                          <label className="form-check-label" htmlFor="myCheck">
                            By submitting your information, you agree that Elite
                            Rewards will use your information solely for reward
                            fulfillment and program administration. All
                            information is kept secure and confidential and will
                            not be sold, shared, or redistributed for marketing
                            or any unrelated purpose. Customer data is retained
                            only as long as necessary to complete fulfillment
                            and meet legal requirements.
                          </label>
                          <div className="errorMsg">
                            {errors.i_agree &&
                            !errors.reward &&
                            !errors.address &&
                            !errors.emailid &&
                            !errors.phone &&
                            !errors.model &&
                            !errors.delivery_date &&
                            !errors.purchase_date &&
                            !errors.store_location &&
                            !errors.ticket &&
                            !errors.lname &&
                            !errors.name
                              ? errors.i_agree
                              : null}
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-5 col-sm-12 ">
                        <div className="d-grid">
                          <button
                            className="btn btn-primary btn-lg "
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="alert alert-info alert-info-custom">
                          Limit 1 per household, while supplies last. Some
                          restrictions apply, see store for detail.
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>

      {/* <Footer2 /> */}
    </>
  );
}
export default RegisterForm;
